import { Button, createTheme } from "@mui/material";
import { grey } from "@mui/material/colors"

const primary = {
    main: "#27292a",
    light: "#27292a",
    dark: "#27292a",
    contrastText: "#eac040"
}

const secondary = {
    main: "#eac040",
    light: "#eac040",
    dark: "#eac040",
    contrastText: "#27292a"
}

export const gcTheme = createTheme(
    {
        cssVariables: true,
        palette: {
           primary: primary,
           secondary: secondary
        },
    }
)